import classNames from 'classnames';
import { useId } from 'react';

const CheckBox = (props) => {
  const {
    field,
    label,
    form,
    required,
    describedByLabel,
    describedByContent,
    labelClass,
    dataTestId,
    onChange
  } = props;
  const { onChange: onFieldChange, value, name } = field;
  const { values } = form;

  const fieldId = useId();

  const id = `c7-${fieldId}-${name}`;
  const labelId = `${id}-label`;

  let ariaDescribedBy;
  if (describedByLabel) {
    ariaDescribedBy = describedByLabel;
  }

  const handleOnChange = (e) => {
    if (onChange) {
      onChange();
    }
    onFieldChange(e);
  };

  return (
    <>
      <label
        className={classNames('c7-checkbox', labelClass)}
        htmlFor={id}
        id={labelId}
      >
        <input
          required={required}
          type="checkbox"
          name={name}
          onChange={handleOnChange}
          checked={values[name] || false}
          value={value}
          id={id}
          aria-labelledby={labelId}
          aria-describedby={ariaDescribedBy}
          data-testid={dataTestId}
        />
        <span className="c7-checkbox__control" />
        <span className="c7-checkbox__label">{label}</span>
        {describedByContent}
      </label>
    </>
  );
};

export default CheckBox;
